"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uniq_1 = require("./uniq");

var union = function union() {
  var sources = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }

  return uniq_1.default([].concat.apply([], sources));
};

exports.default = union;